// extracted by mini-css-extract-plugin
module.exports = {"recommendations":"recommendations_recommendations__El5TA"};